// extracted by mini-css-extract-plugin
export default {"box":"E0V7_Xl2qTcJ440hIQYq"};